import {uiRequest} from "@/api";

const bashUrl = '/web-info/'

/**
 * 获取网站信息
 */
export const webInfo = () => {
    return uiRequest({
        url: `${bashUrl}`,
        method: 'get'
    })
}
